import { useState, useCallback } from 'react';

const MS_IN_DAY = 24 * 60 * 60 * 1000;
const MONTHS = 3 * 30;

const setCookie = dismiss => {
  const date = new Date();
  date.setTime(date.getTime() + MONTHS * MS_IN_DAY);
  document.cookie = `notificationBanner_${dismiss}=true; expires="${date.toUTCString()}"; path=/`;
};

const useShowNotification = notification => {
  const [showNotification, setShowNotification] = useState(
    !!(notification && notification.parameters)
  );

  const setNotification = useCallback(() => {
    if (
      notification.parameters.dismiss &&
      notification.parameters.dismiss !== ''
    ) {
      setCookie(notification.parameters.dismiss);
    }
    setShowNotification(false);
  }, []);

  return [showNotification, setNotification];
};

export default useShowNotification;
